import { Field } from 'formik';
import { FieldProps } from 'formik/dist/Field';
import { FormControlProps } from 'react-bootstrap/FormControl';
import { BsForm, InputProps, parseInputProps } from '../../../../components/form/base';
import { DecoratedFormUnit } from '../../base/DecoratedFormUnit';

export function NumberInput(props: InputProps) {
  const { inputProps, unitProps } = parseInputProps(props);

  return (
    <DecoratedFormUnit {...unitProps}>
      <BsForm.Control type="number" {...(inputProps as FormControlProps)} />
    </DecoratedFormUnit>
  );
}

export function NumberField(props: InputProps) {
  const { name, ...rest } = props;

  return (
    <Field name={name}>
      {(fp: FieldProps) => {
        return (
          <NumberInput
            {...fp.field}
            {...rest}
            error={fp.meta.touched && fp.meta.error}
            disabled={rest.disabled || fp.form.isSubmitting}
          />
        );
      }}
    </Field>
  );
}
